/**
 * Atom icon URL
 * Payment method available in Singapore and Malaysia
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const ATOM_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/61LYQ3RuziTGisarZgaAV1/309f3f1e569609dd0b0095857d6382b5/__2022-05-31_11.44.42.png';
